<template>
  <div class="cmp-gallery" :class="{ lightbox: lightboxActive, singular: computedImages.length === 1 }">
    <i v-if="lightboxActive" @click.stop="lightboxActive = false" class="fa fa-times-circle close-lightbox-btn"></i>
    <div class="gallery-wrapper">
      <div class="current-image">
        
          <div class="magnify-icon">
            <i class="fa fa-search-plus" aria-hidden="true"></i>
          </div>

        <div v-if="activeIndex !== 0" class="nav-control left" @click.stop="navigate(0)">
          <i class="fa fa-angle-left" aria-hidden="true"></i>
        </div>
        <div v-if="activeIndex !== computedImages.length - 1" class="nav-control right" @click.stop="navigate(1)">
          <i class="fa fa-angle-right" aria-hidden="true"></i>
        </div>
          <transition name="fadein">
            <img v-if="computedImages[activeIndex]" :src="computedImages[activeIndex].replace('?r=pr', '?r=')" @click.stop="lightboxActive = true" />
          </transition>
      </div>

      <!-- BESPOKE ROD: Added useThumbnails -->
        <div v-if="computedImages.length > 1" class="thumb-list flex-row-nowrap" :class="['img-nr-' + computedImages.length]">
          <div
            v-for="(image, index) of computedImages"
            :class="{ 'active': index === activeIndex }"
            :key="index"
            @click.stop="selectImage(index)"
            class="thumb-container">
            <div class="thumb-img">
              <img :src="image">
            </div>
          </div>
        </div>
      <!-- END BESPOKE ROD -->
    </div>
  </div>
</template>

<script>
import { Product } from 'src/models/product.model';
export default {
  props: {
    product: { type: Product, required: true },
    // BESPOKE
    useThumbnails: { type: Boolean, required: false, default: false },
    singleImage: { type: Boolean, required: false, default: false },
    skipMainImage: { type: Boolean, required: false, default: false }
    // END BESPOKE
  },
  data () {
    return {
      activeIndex: 0,
      lightboxActive: false
    };
  },
  // BESPOKE
  computed: {
    computedImages() {
      var images = [];
      // Check if the array is not empty and has more than one element
      if (this.singleImage) {
        images = [this.product.imageUrl];
      }
      else if (this.skipMainImage) {
        images = this.product.images.length > 1 ? this.product.images.slice(1).map(element => element) : [];
      } else {
        images = this.product.images;
      }
      return images;
    }
  },
  // END BESPOKE
  methods: {
    selectImage (index) {
      this.activeIndex = index;
    },
    navigate (val) {
      if (val) {
        this.activeIndex++;
      } else {
        this.activeIndex--;
      }
    }
  }
}
</script>

<style>

</style>
